module.exports = __webpack_public_path__ + "img/wave-bg.32bb4716.png";